export default __webpack_public_path__ + "static/SRUS 1130 - Product Specifications & Technical Data-bdce2f2c91be3139e841dab413d97dd6.pdf";